import React from "react"
import type { CriterionScore } from "../../Questions/types"
import "./AssessmentCard.style.scss"

interface QuestionFeedbackProps {
  criteria?: CriterionScore[] | null
  strengths?: string[]
  improvements?: string[]
  suggestedAnswer?: string | null
  examinerFeedback?: string | null
}

const QuestionFeedback = ({
  criteria,
  strengths,
  improvements,
  suggestedAnswer,
  examinerFeedback,
}: QuestionFeedbackProps) => {
  const hasCriteria = !!criteria?.length
  const hasStrengths = !!strengths?.length
  const hasImprovements = !!improvements?.length
  if (
    !hasCriteria &&
    !hasStrengths &&
    !hasImprovements &&
    !suggestedAnswer &&
    !examinerFeedback
  ) {
    return null
  }

  return (
    <div className="assessment-card__expand">
      {hasCriteria && (
        <div className="assessment-card__section">
          <h5>Mark Breakdown</h5>
          {criteria.map((c) => (
            <div key={c.label} className="assessment-card__mark-row">
              <div className="assessment-card__mark-top">
                <span>{c.label}</span>
                <em>
                  {c.marksAwarded}/{c.marksAvailable}
                </em>
              </div>
              {c.rationale && <p>{c.rationale}</p>}
            </div>
          ))}
        </div>
      )}

      {(hasStrengths || hasImprovements) && (
        <div className="assessment-card__grid">
          {hasStrengths && (
            <div className="assessment-card__panel is-strength">
              <h5>Strengths</h5>
              <ul>
                {strengths.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          )}
          {hasImprovements && (
            <div className="assessment-card__panel is-improve">
              <h5>Areas to Improve</h5>
              <ul>
                {improvements.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}

      {suggestedAnswer && (
        <div className="assessment-card__panel is-suggest">
          <h5>Suggested Answer</h5>
          <p>{suggestedAnswer}</p>
        </div>
      )}

      {examinerFeedback && (
        <div className="assessment-card__panel is-note">
          <h5>Examiner Note</h5>
          <p>“{examinerFeedback}”</p>
        </div>
      )}
    </div>
  )
}

export default QuestionFeedback
